module.exports = __webpack_public_path__ + "static/constructions-a5493d647cee4e26354547a2599c2ade.gif";